module.exports = __webpack_public_path__ + "static/media/1f38a.32fcfaa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f38a.svg
// module id = 620
// module chunks = 1